import { ValidationError } from "sequelize"
import {
    QidModelSafetyFunction,
    QidModelSafetyFunctionCreate,
    QidModelSafetyFunctionSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    QidModelSafetyFunctionValidation,
    UpdateQidDependingDevices,
} from "client/store"


export const LoadQidModelSafetyFunctionById = (safetyFunctionId: number) => (
    GET(`/qidModelSafetyFunction/id/${safetyFunctionId}`)
    .then((safetyFunction: QidModelSafetyFunction) => safetyFunction)
)

export const SaveQidModelSafetyFunction = (
    id: number,
    safetyFunction: QidModelSafetyFunctionCreate,
    updated: boolean,
    lang: LangType,
) => {
    const data: QidModelSafetyFunctionSave = {
        id,
        safetyFunction,
    }
    return POST(
        "/qidModelSafetyFunction/save",
        JSON.stringify(data),
    ).then((res) => {
        const newSafetyFunction = res as QidModelSafetyFunction
        const error = res as ValidationError
        const validation = <QidModelSafetyFunctionValidation>validate(error, lang)

        const result = {
            newSafetyFunctionId: newSafetyFunction.id || null,
            validation,
        }

        if (!validation && id && updated) {
            // update SIL project devices
            return UpdateQidDependingDevices({
                update: true,
                qidSafetyFunctionId: id,
            }).then(() => result)
        }
        return result
    })
}

export const DeleteQidModelSafetyFunction = (safetyFunctionId: number, modelId: number, productId: number) => (
    DELETE(`/qidModelSafetyFunction/delete/${safetyFunctionId}`)
    .then((removedRows: number) => {
        if (removedRows === 1) {
            // update SIL project devices
            return Promise.all([
                UpdateQidDependingDevices({
                    update: false,
                    qidProductId: productId,
                    qidModelId: modelId,
                    qidSafetyFunctionId: safetyFunctionId,
                }),
                UpdateQidDependingDevices({
                    update: true,
                    qidProductId: productId,
                    qidModelId: modelId,
                    qidSafetyFunctionId: null,
                }),
                UpdateQidDependingDevices({
                    update: true,
                    qidProductId: productId,
                    qidModelId: null,
                }),
            ]).then(() => removedRows)
        }
        return removedRows
    })
)
